import * as azure from '../node_modules/azure-storage/browser/azure-storage.blob.export';

const account = {
  name: 'collegeweekends',
  accesskey: '/Nm14pZG8gF15XrQLWZFyOWAjCGoKo6UXfAsSiBOta+EABTpspTtZ8LZdDhuhNPvKio2et8J1MG/IimlsjuNBQ==',
  containers: {
    listingContainer: "listing-container"
  }
}
let blobService = azure.createBlobService(account.name, account.accesskey)

export function createBlobsFromArray(files, uniqueId = null) {
  if (files && files.length > 0) {
    let promises = [];
    files.map((file) => {
      promises.push(this.createBlob(file, uniqueId));
    });
    return Promise.all(promises);
  }
  return null;
}

export function createBlob(file, uniqueId = null) {
  if (file.size > 0) {
    var fileName = uniqueId ? uniqueId + '/' + file.name : file.name
    var customBlockSize = file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512;
    blobService.singleBlobPutThresholdInBytes = customBlockSize;

    return new Promise((resolve, reject) => {
      blobService.createBlockBlobFromBrowserFile(account.containers.listingContainer,
        fileName, file, { blockSize: customBlockSize }, function (error, result, response) {
          if (error) {
            return reject(error);
          } else {
            return resolve(result);
          }
        });
    });
  }
  return null;
}
